module.exports = __webpack_public_path__ + "img/7.d007076b.png";